import { AddIcon } from '@diligentcorp/atlas-react-icons';
import { WithTheme } from '@issuemanager/apps/client/theme';
import { Button, ButtonProps, Divider, Stack, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  formIsLoading: boolean;
  handleAddReminderDays: () => void;
};

const StyledDivider = styled(Divider)`
  align-self: center;
  width: 100%;
`;

const StyledButton = styled(Button)<WithTheme<ButtonProps>>(({ theme }) => ({
  width: 'fit-content',
  alignSelf: 'center',
  px: 3,
  color: theme.tokens.semantic.color.action.default.value,
}));

export function DividerMiddleButton(props: Props) {
  const { formIsLoading, handleAddReminderDays } = props;
  const { t } = useTranslation('settings');

  return (
    <Stack
      flexDirection='row'
      alignItems='center'
      justifyContent='space-between'
    >
      <Stack flexGrow={1}>
        <StyledDivider flexItem />
      </Stack>
      <StyledButton
        variant='text'
        startIcon={<AddIcon />}
        disabled={formIsLoading}
        data-testid='add-sla-button'
        onClick={handleAddReminderDays}
      >
        {t('slaConfiguration.sidePanel.addReminder')}
      </StyledButton>
      <Stack flexGrow={1}>
        <StyledDivider flexItem />
      </Stack>
    </Stack>
  );
}
